<section class="pnc-detail-header">
    <div class="pnc-detail-header-type" data-cy="pnc-detail-header-type">{{configuration?.type}}</div>
    <div [ngClass]="$safeNavigationMigration(configuration?.styleClass)" class="pnc-detail-header-status"
         data-cy="pnc-detail-header-status">{{configuration?.status}}</div>
</section>
